import $ from 'jquery';

export default function medEdFilter() {
  const HIDE_CHECKBOXES_WITH_NO_RESULTS = true;

  $('.js-filter-control').on('change', function () {
    const isTaCheckbox = $(this).closest('.js-ta-filter-group').length;
    const $taCheckedCheckboxes = $('.js-ta-filter-group').find('.js-filter-control:checked');

    // Uncheck all checkboxes when toggle therapeutic area checkboxes
    if ( isTaCheckbox && $(this).is(':checked') ) {
      $('.js-filter-group:not(.js-ta-filter-group) .js-filter-control:checked').prop('checked', false).trigger('change');
    }

    // While therapeutic area checkboxes are not checked, do not show the cards
    if ( $taCheckedCheckboxes.length ) {
      $('.js-main-content-subtitle').hide();
      $('.js-cards-container').removeClass('is-hidden');
    } else {
      $('.js-main-content-subtitle').show();
      $('.js-cards-container').addClass('is-hidden');
    }
  });

  // GTM
  $('.js-filter-control').on('click', function () {
    const values = [];

    setTimeout(() => {
      $('.js-filter-control:checked').each(function () {
        values.push($(this).val());
      });

      if ( values.length ) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'checkbox__caption',
          'checkboxCaption': values.join(', '),
        });
      }
    }, 100);
  });

  // Hide filter checkboxes with no results
  if ( HIDE_CHECKBOXES_WITH_NO_RESULTS ) {
    const ignoreKeys = ['therapeuticArea'];

    $('.js-filter-control').on('change', function () {
      const $activeCheckbox = $(this);
      const $selectedCheckboxes = $('.js-filter-control:checked');

      if ( !$selectedCheckboxes.length ) {
        $('.js-filter-checkbox').removeClass('is-hidden');
        $('.js-filter-group:not(.js-ta-filter-group), .js-keywords-filter-group').addClass('is-hidden');
      } else {
        $('.js-keywords-filter-group').removeClass('is-hidden');
      }

      if ( $('.js-cards-container').hasClass('is-hidden') ) {
        return;
      }

      const availableFilters = {
        creditRange: {
          min: 0,
          max: 0,
        },
      };
      const $activeCards = $('.js-filterable-item:not(.is-hidden)');

      // get available filter options from cards
      $activeCards.each(function () {
        const $card = $(this);
        const cardData = $card.data();

        for (const dataKey in cardData) {
          let dataValue = cardData[dataKey];

          if ( ignoreKeys.includes(dataKey) ) {
            continue;
          }

          if ( dataKey === 'creditMin' ) {
            dataValue = +dataValue;

            availableFilters.creditRange.min = availableFilters.creditRange.min < dataValue
              ? availableFilters.creditRange.min
              : dataValue;
          } else if ( dataKey === 'creditMax' ) {
            dataValue = +dataValue;

            availableFilters.creditRange.max = availableFilters.creditRange.max > dataValue
              ? availableFilters.creditRange.max
              : dataValue;
          } else {
            dataValue = typeof dataValue === 'string' && dataValue.toLowerCase().split(',');

            availableFilters[dataKey] = availableFilters.hasOwnProperty(dataKey)
              ? [...new Set(availableFilters[dataKey].concat(dataValue))]
              : [...dataValue];
          }
        }
      });

      // toggle checkboxes
      for ( const availableFilterKey in availableFilters ) {
        $(`.js-filter-control[name="${availableFilterKey}"]`)
          .not(':checked') // exclude checked checkboxes
          .not($activeCheckbox.closest('.js-filter-group').find('.js-filter-control')) // exclude siblings checkboxes
          .each(function () {
            const isCreditRangeCheckbox = $(this).attr('name') === 'creditRange';
            let statement;

            if ( isCreditRangeCheckbox ) {
              const values = $(this).val().split('-');
              const minValue = +values[0];
              const maxValue = +values[1];

              statement = ( availableFilters.creditRange.min >= minValue && availableFilters.creditRange.max <= maxValue )
                || ( availableFilters.creditRange.min < maxValue && availableFilters.creditRange.max >= minValue );
            } else {
              const value = $(this).val().toLowerCase();

              statement = availableFilters[availableFilterKey].includes(value);
            }

            $(this).closest('.js-filter-checkbox').toggleClass('is-hidden', !statement);
          });
      }

      // hide filter group if there are no visible checkboxes
      $('.js-filter-group:not(.js-ta-filter-group)').each(function () {
        const $visibleCheckboxes = $(this).find('.js-filter-checkbox:not(.is-hidden)');

        if ( !$visibleCheckboxes.length ) {
          $(this).addClass('is-hidden');
        } else {
          $(this).removeClass('is-hidden');
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/project/med-ed-filter.js